<ppg-rich-text [content]="resourceValue()" />
